import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=44913477&scoped=true"
import script from "./wxlogin.vue?vue&type=script&lang=js"
export * from "./wxlogin.vue?vue&type=script&lang=js"
import style0 from "./wxlogin.vue?vue&type=style&index=0&id=44913477&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44913477",
  null
  
)

export default component.exports